import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, NgZone } from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { InvoiceModel } from "../models/invoice.model";

const moment = require("moment");

@Component({
  selector: 'missing-iban-popup',
  template: require('../views/missing-iban-popup.component.html'),
})

export class MissingIBANPopupComponent implements OnInit {
  // instanceNameCaption: string;
  // DriverNameCaption: string;
  apiErrorMsg: any;
  _model: InvoiceModel[];

  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;

  @ViewChild('missingIBANModel') public missingIBANModel: any;

  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();

  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService
    , private zone: NgZone) {

  }

  @Input()
  set model(_invoiceList: InvoiceModel[]) {
    this._model = _invoiceList;
  }
  get model() { return this._model; }

  ngOnInit() {
  }

  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];
    this.missingIBANModel.show();
  }

  public hide(): void {
    this.model = InvoiceModel[0];
    this.missingIBANModel.hide();
  }

  public OnExport(event: any) { 

    var exportData = this.model.map(function (val) {
      return {
        "LblDriverName": val.driverName,
        "LblInstance": val.instanceName
      };
    });

    this.JSONToCSVConvertor(exportData, "Missing_IBAN", true);
  }

  public JSONToCSVConvertor(JSONData: any, ReportTitle: any, ShowLabel: any) {
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
      var row = "";
      //This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {
        //Now convert each value to string and comma-seprated
        row +=  this.translate.instant(index) + ',';
      }
      row = row.slice(0, -1);
      CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = "";
      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      //add a line break after each row
      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "File_";
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, "_");

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension    

    //this trick will generate a temp a /> tag
    let link: any = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private OnSuccessSave() {
    this.hide();
    let successMsg = this.translate.instant('LblSuccess');
    this.onSuccessSave.emit({ SuccessMessage: successMsg })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/missing-iban-popup.component.ts